export default __webpack_public_path__ + "static/media/e-univer.bcc9a790.svg";